/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Add_Customer_Copilot_BundledInputs */



/**
* | output |
* | --- |
* | "Included with Gateway." |
*
* @param {Partner_Add_Customer_Copilot_BundledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_add_customer_copilot_bundled = /** @type {((inputs?: Partner_Add_Customer_Copilot_BundledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Add_Customer_Copilot_BundledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Im Gateway-Tarif enthalten.")
	return /** @type {LocalizedString} */ ("Included with Gateway.")
});